import axios from "axios";

import { routesConfig } from "../models/routesConfig";
import { store } from "../store";
import { setNeedUserLogin } from "../Reducers/default-reducers/globalConfigReducer";


export const setRestApi = (context, baseEndPoint) => {

   let endPointToConfig = null
   if (baseEndPoint) {
      endPointToConfig = baseEndPoint
   } else {
      routesConfig.forEach(rC => rC.routes.forEach(route => {
         if (route.configuration.context === context) {
            endPointToConfig = route.configuration.endPoint
         }
      }))
   }

   const http = axios.create({
      baseURL: endPointToConfig,
   });

   http.interceptors.response.use((response) => {

      return response.data.content ? response.data.content : response.data

   }, error => {
      console.error('API Error:', error?.response?.status, error?.response?.data || error.message);

      const status = error.response?.status;
      const data = error.response?.data;

      if (status === 401 || (status === 403 && typeof data === 'string' && data.includes("A token is required for authentication"))) {
         store.dispatch(setNeedUserLogin(true));

         return new Promise((resolve, reject) => {
            const unsubscribe = store.subscribe(() => {
               const state = store.getState();
               const token = state.global.token;
               const needLogin = state.global.needUserLogin;

               if (token && !needLogin) {
                  unsubscribe();
                  error.config.headers['Authorization'] = `${token}`;
                  http.request(error.config).then(resolve).catch(reject);
               } else if (!token && !needLogin) {
                  unsubscribe();
                  reject(error);
               }
            });
         });
      }

      // Check if response data is HTML (error page)
      if (data && typeof data === 'string' && data.includes('<!DOCTYPE html>')) {
         return Promise.reject({
            status: status,
            message: `Server error (${status}): Cannot ${error.config?.method?.toUpperCase()} ${error.config?.url}`,
            isHtmlError: true
         });
      }

      return Promise.reject(error);
   });


   http.interceptors.request.use(async (config) => {
      const token = store.getState().global.token;
      if (token) {
         config.headers.Authorization = `${token}`;
      }

      return config;
   }, error => {
      return error
   });

   return http;
};

